import { personCost, rateIn, sumCosts, teamAt, type VersionTeam } from '../products/productDetail/budget';
import { fractionalRate, type FractionalPerson } from '../products/productDetail/fractional';

/** The ceiling on what arriving at the tab costs: every product priced is a few reads. */
export const MAX_PRICED = 8;

/** One product's year: what each sprint of it brought in, by sprint id. */
export interface ProductRevenue {
  id: string;
  name: string;
  bySprint: Record<string, number>;
  /** The hours behind it, reported and bought in, by sprint id. */
  hoursBySprint: Record<string, number>;
  /** What each sprint was projected to cost, as the product's own projections price it. */
  projectedBySprint: Record<string, number>;
  projectedHoursBySprint: Record<string, number>;
}

/** The three parts the product's own Spend tab adds up: hours at the day's rate, bought-in rows, less the discount. */
export const sprintRevenue = (
  teams: VersionTeam[],
  day: string,
  hours: Record<string, number>,
  boughtIn: { hours: Record<string, number>; roster: FractionalPerson[] } = { hours: {}, roster: [] },
  discount = 0,
  /** A fixed-price version's charge for the sprint, which stands in for the team's hours. */
  fixed: number | null = null,
): number => {
  const team = teamAt(teams, day);
  const worked = Object.entries(hours).map(([memberId, amount]) => personCost(rateIn(team, memberId), amount));
  const bought = Object.entries(boughtIn.hours).map(([personId, amount]) =>
    personCost(fractionalRate(boughtIn.roster, personId), amount),
  );

  return sumCosts([...(fixed === null ? worked : [fixed]), ...bought, -discount]);
};
